// extracted by mini-css-extract-plugin
export default {"loader":"CircleLoader_loader__K1s7N","spin":"CircleLoader_spin__+vDly"};